import Request from './request';

async function tree(data) {
    return Request('get', "api/material-show-categories/tree", data);
}

async function save(id,data) {// 编辑或新建数据（有id为编辑，没有id为新建）
    if (id) {
        return Request('post', "api/material-show-categories/edit?id=" + id, data);
    } else {
        return Request('post', "api/material-show-categories/add" , data);
    }
}

async function del(id) {
    return Request('get', "api/material-show-categories/delete/", id ? { id: id} : {});
}

async function levelOneList(data) {
    return Request('get', "api/material-show-categories/levelOneList", data);
}

async function materialShowCategoriesList(data) {
    return Request('get', "api/material-show-categories/list", data);
}

export default {
    tree,
    save,
    del,
    levelOneList,
    materialShowCategoriesList
};